import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IQuestion, IResponse, ISaveAnswerParams, ISingleParam } from '@interfaces/index';
import { AssessmentService } from '../../services/assessment.service';
import { Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrl: './text.component.scss'
})
export class TextComponent {

  @Input() question: IQuestion | null = null;
  @Input() token: string | null = null;
  @Output() onNext: EventEmitter<void> = new EventEmitter()

  private input_value = new Subject<string>();

  constructor(
    public assessment_service: AssessmentService
  ) { 
    this.input_value.pipe(
      debounceTime(800),
      distinctUntilChanged(),
      switchMap(
        (value: string) => {
          (this.question as IQuestion).user_supplied_answer_text = value;
          return this.assessment_service.saveAnswer<ISaveAnswerParams<ISingleParam>>({
            answer: {
              answer_text: (this.question as IQuestion).user_supplied_answer_text
            },
            question_id: (this.question as IQuestion).question_id,
            token: this.token as string
          })
        }
      )
    ).subscribe(
      (response: IResponse<any>) => {
      }
    )
  }

  setValue(input: InputEvent | any) {
    if(input.target) {
      this.input_value.next(input.target.value)
    }
  }

}
